
import Vue from 'vue';
import { getList } from '../api';

export default Vue.extend({
  data() {
    return {
      groupList: [] as {
        name: string;
        teams: { rank: number; name: string; score: string }[];
      }[],
    };
  },
  async created() {
    setTimeout(async () => {
      try {
        const ret: any = await getList();
        if (ret.code === 200 && Array.isArray(ret.data)) {
          this.groupList = this.buildGroupList(ret.data);
        }
      } catch (e) {
        console.error('获取小组赛数据失败', e);
      }
    }, 100);
  },
  methods: {
    buildGroupList(data: any[]) {
      const map: Record<string, any[]> = {};
      data.forEach((item) => {
        if (!map[item.group]) {
          map[item.group] = [];
        }
        map[item.group].push(item);
      });

      return Object.keys(map)
        .sort()
        .map((group) => ({
          name: group,
          teams: map[group]
            .sort((a, b) => Number(a.sort) - Number(b.sort))
            .map((item) => ({
              rank: Number(item.sort),
              name: item.name,
              score: item.points != null ? item.points : '',
            })),
        }));
    },
  },
});
